import React from "react";
import "./loadervolan.css";
import loaderImg from "../img/Loader.png";

export default function LoaderVolan() {
  return (
    <div className="loader-overlay">
      <div className="loader-inner">

        <div className="loader-wheel-wrap">
          <img
            src={loaderImg}
            alt="Učitavanje..."
            className="loader-wheel"
          />
          <div className="loader-ring" />
        </div>

        <div className="loader-bar-track">
          <div className="loader-bar-fill" />
        </div>

        <p className="loader-label">Učitavam materijale...</p>

      </div>
    </div>
  );
}